import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/styles';
import { Divider, Drawer } from '@material-ui/core';
import {
  Assignment as AssignmentIcon,
  Settings as SettingsIcon,
  PeopleAlt as PeopleAltIcon,
  Person as PersonIcon,
  // Dashboard as DashboardIcon
  AttachMoney as AttachMoneyIcon,
  Schedule as ScheduleIcon,
  PostAdd as PostAddIcon,
  // ChromeReaderMode as ChromeReaderModeIcon,
  ListAlt as ListAltIcon,
  Receipt as ReceiptIcon
} from '@material-ui/icons';

import * as selectorsAuth from '../../../../../../store/auth/reducer';
import * as selectorsModuleConfiguration from '../../../../../../store/moduleConfiguration/reducer';
import * as Role from '../../../../../../constants/role';

import Profile from './Profile';
import SidebarNav from './SidebarNav';
import { isUsuarioUsoMuto } from 'utils';
import { renderFolhaPonto, renderPedidoVoo } from '../../../sidebarMenu/renderMenuOption';
import { isRoleAuditoriaNsir } from '../../../../../../helpers/auditoriaNsirPermission';

const useStyles = makeStyles(theme => ({
  drawer: {
    width: 240,
    [theme.breakpoints.up('lg')]: {
      marginTop: 64,
      height: 'calc(100% - 64px)',
      borderRight: 'none'
    }
  },
  root: {
    backgroundColor: theme.palette.bar.principal,
    display: 'flex',
    height: '150%',
    flexDirection: 'column',
    padding: theme.spacing(2)
  },
  divider: {
    margin: theme.spacing(2, 0),
    backgroundColor: theme.palette.bar.light
  }
}));

const Sidebar = ({ open, variant, onClose, userRole, authData, moduleConfigurations }) => {
  const classes = useStyles();

  const pages = () => ([
    {
      title: 'Meu Perfil',
      icon: <PersonIcon />,
      href: '/meu-perfil',
      show: true,
    },
    {
      title: 'Inspeção',
      icon: <AssignmentIcon />,
      show: !isUsuarioUsoMuto(authData.email) || isRoleAuditoriaNsir(userRole),
      key: 'inspecao',
      isActiveCallback: () => {},
      options: [
        {
          title: 'NSIRs',
          href: '/nsirs',
          isActive: (match, location) => match || (location && location.pathname.includes('/nsir')),
          show: !isUsuarioUsoMuto(authData.email) || isRoleAuditoriaNsir(userRole),
          key: 'inspecao',
        },
        {
          title: 'Convocações',
          href: '/v2/convocacoes',
          show: !isUsuarioUsoMuto(authData.email) && !isRoleAuditoriaNsir(userRole),
          key: 'inspecao',
        },
        {
          title: 'Equipamentos',
          href: '/equipamentos',
          show: process.env.REACT_APP_EQUIPAMENTO_VIEW.split(',').includes(authData.email) && !isUsuarioUsoMuto(authData.email) && !isRoleAuditoriaNsir(userRole),
          key: 'inspecao',
        },
        {
          title: 'Controle de Jornada',
          href: '/controle-frequencia',
          show: !isUsuarioUsoMuto(authData.email) && !isRoleAuditoriaNsir(userRole),
          key: 'inspecao',
        },
        ...renderFolhaPonto(authData, moduleConfigurations, userRole),
        {
          title: 'Programação Diária',
          href: '/v2/programacao-diaria',
          show: !isUsuarioUsoMuto(authData.email) && !isRoleAuditoriaNsir(userRole),
          key: 'inspecao',
        },
        ...renderPedidoVoo(authData, moduleConfigurations),
        {
          title: 'Relatórios Digitadores',
          href: '/reports',
          show: (process.env.REACT_APP_USUARIO_VIEW_DIGITADOR_REPORT.split(',').includes(authData.email) || authData.role === Role.DIGITADOR) && !isUsuarioUsoMuto(authData.email) && !isRoleAuditoriaNsir(userRole),
          key: 'inspecao',
        },
        {
          title: 'Integrações',
          href: '/v2/integracoes',
          show: (process.env.REACT_APP_USUARIO_VIEW_DIGITADOR_REPORT.split(',').includes(authData.email) || authData.role === Role.DIGITADOR) && !isUsuarioUsoMuto(authData.email) && !isRoleAuditoriaNsir(userRole),
          key: 'inspecao',
        },
      ]
    },
    {
      title: 'Financeiro',
      icon: <AttachMoneyIcon />,
      show: !isUsuarioUsoMuto(authData.email) && !isRoleAuditoriaNsir(userRole),
      key: 'financeiro',
      options: [
        {
          title: 'Aportes',
          href: '/v2/aportes',
          isActive: (match, location) => match || (location && location.pathname.includes('/aporte')),
          show: userRole !== Role.CROQUI && userRole !== Role.DIGITADOR && !isUsuarioUsoMuto(authData.email) && !isRoleAuditoriaNsir(userRole),
          key: 'financeiro',
        },
        {
          title: 'Cartões',
          href: '/v2/cartoes',
          show: (userRole === Role.SUPER_ADMIN || userRole === Role.ADMIN) && !isUsuarioUsoMuto(authData.email) && !isRoleAuditoriaNsir(userRole),
          key: 'financeiro',
        },
        // {
        //   title: 'Controle de Caixa',
        //   href: '/controle-caixa',
        //   show: userRole === Role.SUPER_ADMIN || userRole === Role.ADMIN
        // },
        {
          title: 'Notas',
          href: '/v2/notas',
          show: userRole !== Role.CROQUI && userRole !== Role.DIGITADOR && !isUsuarioUsoMuto(authData.email) && !isRoleAuditoriaNsir(userRole),
          key: 'financeiro',
        },
        {
          title: 'Odômetros',
          href: '/v2/odometros',
          show: !isUsuarioUsoMuto(authData.email) && !isRoleAuditoriaNsir(userRole),
          key: 'financeiro',
        },
        {
          title: 'Veículos',
          href: '/veiculos',
          show: (userRole === Role.SUPER_ADMIN || userRole === Role.ADMIN) && !isUsuarioUsoMuto(authData.email) && !isRoleAuditoriaNsir(userRole),
          key: 'financeiro',
        },
        {
          title: 'Inspeções Veiculares',
          href: '/v2/inspecoes-veiculares',
          show: !isUsuarioUsoMuto(authData.email) && !isRoleAuditoriaNsir(userRole),
          key: 'financeiro',
        },
        {
          title: 'Holerite',
          href: '/v2/olerites',
          show: !isUsuarioUsoMuto(authData.email) && !isRoleAuditoriaNsir(userRole),
          key: 'financeiro',
        },
      ]
    },
    {
      title: 'Estoque',
      icon: <PostAddIcon />,
      show: process.env.REACT_APP_ESTOQUE_VIEW.split(',').includes(authData.email) && !isRoleAuditoriaNsir(userRole),
      key: 'estoque',
      options: [
        {
          title: 'Estoque',
          href: '/v2/estoques',
          show: process.env.REACT_APP_ESTOQUE_VIEW.split(',').includes(authData.email) && !isRoleAuditoriaNsir(userRole),
          key: 'estoque',
        },
        {
          title: 'Pedidos',
          href: '/v2/estoque/pedidos',
          isActive: (match, location) => match || (location && location.pathname.includes('/v2/estoque/pedidos')),
          show: process.env.REACT_APP_ESTOQUE_VIEW.split(',').includes(authData.email) && !isRoleAuditoriaNsir(userRole),
          key: 'estoque',
        },
        {
          title: 'Produtos',
          href: '/v2/estoque/produtos',
          isActive: (match, location) => match || (location && location.pathname.includes('/v2/estoque/produtos')),
          show: process.env.REACT_APP_ESTOQUE_VIEW.split(',').includes(authData.email) && !isRoleAuditoriaNsir(userRole),
          key: 'estoque',
        }
      ]
    },
    {
      title: 'Usuários',
      icon: <PeopleAltIcon />,
      show: !isUsuarioUsoMuto(authData.email) && !isRoleAuditoriaNsir(userRole),
      key: 'usuarios',
      options: [
        {
          title: 'Listagem',
          href: '/usuarios',
          show: true,
          key: 'usuarios',
        },
        {
          title: 'Documentos e Certificados',
          href: '/usuarios-documentos',
          show: authData.email === 'vinicius_admin' || authData.email === 'MARIA' || authData.email === 'REGIANE MARIA DE OLIVEIRA' || authData.email === 'JORDANIA FLORENCIO MOTA',
          key: 'usuarios',
        },
      ]
    },
    {
      title: 'Controle de Ponto',
      icon: <ScheduleIcon />,
      href: '/controle-ponto',
      show: process.env.REACT_APP_CONTROLE_PONTO_VIEW.split(',').includes(authData.email) && !isRoleAuditoriaNsir(userRole),
    },
    {
      title: 'Procedimentos e Normas',
      icon: <ListAltIcon />,
      href: '/procedimentos-normas',
      show: !isUsuarioUsoMuto(authData.email) || isRoleAuditoriaNsir(userRole),
    },
    {
      title: 'Configurações',
      icon: <SettingsIcon />,
      show: (userRole === Role.SUPER_ADMIN || userRole === Role.ADMIN) && !isUsuarioUsoMuto(authData.email) && !isRoleAuditoriaNsir(userRole),
      key: 'configurations',
      options: [
        {
          title: 'Documentos',
          href: '/v2/documentos',
          show: true,
          key: 'configurations',
        },
        {
          title: 'Malhas',
          href: '/v2/malhas',
          show: true,
          key: 'configurations',
        },
        {
          title: 'Gerências',
          href: '/v2/gerencias',
          show: true,
          key: 'configurations',
        },
        {
          title: 'Polos',
          href: '/v2/polos',
          show: true,
          key: 'configurations',
        },
        {
          title: 'Subestações',
          href: '/v2/subestacoes',
          show: true,
          key: 'configurations',
        },
        {
          title: 'Alimentadores',
          href: '/v2/alimentadores',
          show: true,
          key: 'configurations',
        }
      ]
    },
  ]);

  return (
    <Drawer
      anchor="left"
      classes={{ paper: classes.drawer }}
      onClose={onClose}
      open={open}
      variant={variant}
    >
      <div className={classes.root}>
        <Profile />
        <Divider className={classes.divider} />
        <SidebarNav pages={pages()}/>
      </div>
    </Drawer>
  );
};

Sidebar.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  open: PropTypes.bool.isRequired,
  variant: PropTypes.string.isRequired
};

const mapStateToProps = state => ({
  userRole: selectorsAuth.getRole(state),
  authData: selectorsAuth.getAuth(state),
  moduleConfigurations: selectorsModuleConfiguration.getModuleConfigurations(state),
});

export default connect(mapStateToProps)(Sidebar);